const __OPTIONS = {

    // ideally, this should be generated from the backend (for future)
    api: {
        keys: {
            // default:        'AIzaSyAnh4UY0BLf_tIYpR5WhZdV7OG-I4FPLA8', // with restriction
            // noRestriction:  'AIzaSyCqRosPnlrm_6y1dcHXyMwBiHmmjBLgPgo', // e.g. for reverse geo coding (this api call requires that there is absolutely zero restriction)

            // Alternate
            // default:            'AIzaSyD3i43U1XbxwnYa4ZOxYFGPl2Nn7jRx8bY',
            // noRestriction:      'AIzaSyAAVunoJLIzv54LtLZWZNyMpc_8sQE0DTs',

            // CAA Provided
            // default:        'AIzaSyCpr8Ej6AP-l3aplmamkkFs2X8WmaFSmFI', // with restriction
            // noRestriction:  'AIzaSyCpr8Ej6AP-l3aplmamkkFs2X8WmaFSmFI'  // e.g. for reverse geo coding (this api call requires that there is absolutely zero restriction)
        }
    },
    styles: [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#444444"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f2f2f2"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 45
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#46bcec"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#13b5ea"
                }
            ]
        }
    ],
    icons: {
        base: {
            path: "M16.2,0 C8.1,0 0.9,6.66 0.9,14.4 C0.9,14.94 0.9,15.48 1.08,16.02 C1.44,21.6 4.32,25.56 7.2,29.88 C10.98,35.46 15.3,41.94 15.3,53.1 C15.3,53.64 15.66,54 16.2,54 C16.74,54 17.1,53.64 17.1,53.1 C17.1,41.76 21.42,35.46 25.2,29.88 C28.08,25.56 30.96,21.6 31.32,16.2 C31.32,15.66 31.5,15.12 31.5,14.58 C31.5,6.66 24.3,0 16.2,0 Z M16.2,7.2 C19.62,7.2 22.5,10.08 22.5,13.5 C22.5,16.92 19.62,19.8 16.2,19.8 C12.78,19.8 9.9,16.92 9.9,13.5 C9.9,10.08 12.78,7.2 16.2,7.2 Z",
            fillColor: '#FF0000',
            fillOpacity: 1,
            // anchor: new google.maps.Point(0,0),
            strokeWeight: 0,
            scale: 1,
            size: new google.maps.Size(71, 71),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 58),
            scaledSize: new google.maps.Size(25, 25)
        },

        segmentIcon: {
            path: "M11.5 0C5.412 0 0 5.057 0 10.933c0 .41 0 .82.135 1.23.27 4.237 2.436 7.244 4.6 10.524 2.841 4.236 6.089 9.156 6.089 17.63 0 .41.27.683.676.683s.676-.273.676-.683c0-8.61 3.248-13.394 6.089-17.63 2.164-3.28 4.33-6.287 4.6-10.387 0-.41.135-.82.135-1.23C23 5.057 17.588 0 11.5 0z",
            fillColor: '#ee3224',
            fillOpacity: 1,
            // anchor: new google.maps.Point(0,0),
            strokeWeight: 0,
            scale: 1,
            size: new google.maps.Size(43, 61),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(11, 43),
            scaledSize: new google.maps.Size(43, 61),
            labelOrigin: new google.maps.Point(12, 13),
        },

        // iconB: __OPTIONS.icons.iconA,
    }

} // __OPTIONS

export default __OPTIONS;
